// extracted by mini-css-extract-plugin
export default {"input":"poup_input__yhuVP","pb12":"poup_pb12__lgTmX","pt4":"poup_pt4__tOBD0","pt12":"poup_pt12__MCJGI"};